// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0f3cfcdb","770":"9c91af8e"}[chunkId] + ".chunk.js";
};